/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface UpdateCreditData {
  incrementFreeCreditByInTomans?: string;
  incrementPaidCreditByInTomans?: string;
}

export interface IdInput {
  id: string;
}

export interface UpdateCreditInput {
  data: UpdateCreditData;
  where: IdInput;
}

export interface CreditModel {
  freeCreditInDollars: string;
  paidCreditInDollars: string;
  lastTokenCountCharged: string;
}

export interface BuyCreditInput {
  amount: number;
}

export interface BuyCreditOutput {
  url: string;
}

export interface MoneyToMessageInput {
  type: MoneyToMessageInputTypeEnum;
  amount: string;
}

export interface MoneyToMessageOutput {
  money: string;
  message: string;
}

export interface CalcMessageToTomanInput {
  modelName: string;
  amount: number;
  hasBenefit: boolean;
}

export interface CalcMessageToTomanOutput {
  toman: string;
}

export interface CalcTomanToMessageInput {
  modelName: string;
  toman: string;
  hasBenefit: boolean;
}

export interface CalcTomanToMessageOutput {
  messageAmount: string;
}

export enum AiModelType {
  Free = "Free",
  Premium = "Premium",
}

export interface ReadAiModelWhereData {
  id?: string;
  name?: string;
  type?: AiModelType;
}

export interface PaginationData {
  /**
   * @min 0
   * @default 10
   */
  take?: number;
  /**
   * @min 0
   * @default 0
   */
  skip?: number;
}

export interface PaginationTakeAll {
  takeAll: string;
}

export interface PaginationTakeAllData {
  /**
   * @min 0
   * @default 10
   */
  take?: number;
  /**
   * @min 0
   * @default 0
   */
  skip?: number;
}

export interface ReadAiModelInput {
  where?: ReadAiModelWhereData;
  pagination?: PaginationTakeAllData;
}

export interface AiModelModel {
  id: string;
  name: string;
  type: AiModelType;
  benefitPercent: string;
  perInputTokenPriceInDollars: string;
  perOutputTokenPriceInDollars: string;
  description?: string;
  active: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface ReadAiModelOutput {
  count: number;
  data: AiModelModel[];
}

export interface UpdateAiModelData {
  type?: AiModelType;
  benefitPercent?: number;
  description?: string;
  perInputTokenPriceInDollars?: string;
  perOutputTokenPriceInDollars?: string;
  active?: boolean;
}

export interface UpdateAiModelInput {
  data: UpdateAiModelData;
  where: IdInput;
}

export interface ReadReferencePriceInput {
  title?: string;
  isActivated?: boolean;
}

export interface ReferencePriceModel {
  id: string;
  title: string;
  price: string;
  isActivated: boolean;
}

export interface ReadReferencePriceOutput {
  count: number;
  data: ReferencePriceModel[];
}

export interface ReadPaymentWhereInput {
  userId?: string;
  userName?: string;
}

export interface ReadPaymentInput {
  where?: ReadPaymentWhereInput;
  pagination?: PaginationData;
}

export interface TransactionModel {
  id: string;
  userId: string;
  sessionId: string;
  amount: string;
  currency: string;
  status: TransactionModelStatusEnum;
  processorCode: string;
  referenceId: string;
  verificationDate: string;
  createdDate: string;
  updatedDate: string;
}

export interface ReadPaymentOutputData {
  id: string;
  product: ReadPaymentOutputDataProductEnum;
  description: string | null;
  transactionId: string;
  userId: string;
  transaction: TransactionModel;
  userName: string;
}

export interface ReadPaymentOutput {
  count: number;
  data: ReadPaymentOutputData[];
}

export interface VerifyCreditPaymentInput {
  authority: string;
}

export interface ReadVerifiedPaymentInput {
  authority: string;
}

export interface ReadVerifiedTransactionOutputData {
  id: string;
  product: ReadVerifiedTransactionOutputDataProductEnum;
  description: string | null;
  transactionId: string;
  userId: string;
  transaction: TransactionModel;
}

export interface ReadVerifiedTransactionOutput {
  data: ReadVerifiedTransactionOutputData;
}

export type ReadMyPaymentWhereInput = object;

export interface ReadMyPaymentInput {
  where?: ReadMyPaymentWhereInput;
  pagination?: PaginationData;
}

export interface ReadMyPaymentOutputData {
  id: string;
  product: ReadMyPaymentOutputDataProductEnum;
  description: string | null;
  transactionId: string;
  userId: string;
  transaction: TransactionModel;
}

export interface ReadMyPaymentOutput {
  count: number;
  data: ReadMyPaymentOutputData[];
}

export interface ReadIncomeWhereInput {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  unit: number;
}

export interface ReadIncomeInput {
  where: ReadIncomeWhereInput;
}

export interface ReadIncomeData {
  startDate: string;
  endDate: string;
  totalAmount: string;
}

export interface ReadIncomeOutput {
  data: ReadIncomeData[];
  totalIncome: string;
}

export interface ReadTotalIncomeInput {
  day: number;
}

export interface ReadTotalIncomeOutput {
  IncomeProgressPercent: string;
  amount: string;
  lastDateIncome: string;
}

export interface ReadBenefitIncome {
  day: number;
}

export interface ReadBenefitOutput {
  benefitProgressPercent: string;
  amount: string;
}

export interface ReadCostIncome {
  day: number;
}

export interface ReadCostOutput {
  costProgressPercent: string;
  amount: string;
}

export interface ReadIncomeOutcomeWhereInput {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  unit: number;
}

export interface ReadIncomeOutcomeInput {
  where: ReadIncomeOutcomeWhereInput;
}

export interface ReadIncomeOutcomeData {
  startDate: string;
  endDate: string;
  totalCost: string;
}

export interface ReadIncomeOutcomeOutput {
  income: ReadIncomeOutcomeData[];
  outcome: ReadIncomeOutcomeData[];
}

export interface SystemConfigModel {
  id: string;
  freeCreditIntervalDay: number;
  freeCreditAmountInDollars: string;
}

export interface UpdateSystemConfigInput {
  freeCreditIntervalDay?: number;
  freeCreditAmountInDollars?: string;
}

export interface CreatePromptConversationData {
  data?: object;
  id: string;
  modelName: string;
  promptId: string;
}

export interface CreatePromptConversationInput {
  data: CreatePromptConversationData;
}

export interface MessageModel {
  id: string;
  loading: boolean;
  error: string | null;
  content: string | null;
  modelId: string;
  modelName: string;
  audioId: string | null;
  audioUrl: string | null;
  type: MessageModelTypeEnum;
  createdDate: string;
  updatedDate: string;
}

export interface MessageTupleModel {
  question?: MessageModel;
  answer: MessageModel;
}

export interface PromptConversationModel {
  id: string;
  name: string;
  createdDate: string;
  updatedDate: string;
  userId: string;
  messages: MessageTupleModel;
}

export enum PromptSchemaValidationEnum {
  Required = "Required",
  IsString = "IsString",
  IsNumber = "IsNumber",
  IsSelect = "IsSelect",
}

export enum PromptSchemaTypeEnum {
  Select = "Select",
  Text = "Text",
  Number = "Number",
  TextArea = "TextArea",
}

export interface PromptSchemaModel {
  name: string;
  label: string;
  validation: PromptSchemaValidationEnum[];
  type: PromptSchemaTypeEnum;
  options?: string[];
}

export interface PromptModel {
  id: string;
  content: string;
  title: string;
  description: string;
  useCount: number;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  tagId: string;
  image?: string;
  schema: PromptSchemaModel[];
}

export interface CreatePromptSchemaData {
  name: string;
  label: string;
  validation: PromptSchemaValidationEnum[];
  type: PromptSchemaTypeEnum;
  options?: string[];
}

export interface CreatePromptInput {
  content: string;
  title: string;
  description: string;
  tagId: string;
  schema?: CreatePromptSchemaData[];
}

export interface ChangePromptImageInput {
  /** @format binary */
  file: File;
  promptId: string;
}

export interface UpdatePromptData {
  tagId?: string;
  content?: string;
  title?: string;
  description?: string;
  schema?: CreatePromptSchemaData[];
}

export interface UpdatePromptInput {
  data: UpdatePromptData;
  where: IdInput;
}

export interface UpdateLikePromptOutput {
  success: boolean;
}

export interface UpdateUsageCountPromptOutput {
  success: boolean;
}

export interface CreatePromptTagInput {
  name: string;
}

export interface PromptWithLikesModel {
  id: string;
  content: string;
  title: string;
  description: string;
  useCount: number;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  tagId: string;
  image?: string;
  schema: PromptSchemaModel[];
  userLikesId?: IdInput[];
}

export interface PromptTagModel {
  id: string;
  name: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  prompts: PromptWithLikesModel[];
}

export interface UpdatePromptTagWhereData {
  id: string;
}

export interface UpdatePromptTagData {
  name: string;
}

export interface UpdatePromptTagInput {
  where: UpdatePromptTagWhereData;
  data?: UpdatePromptTagData;
}

export interface ReadPromptTagWhereData {
  name?: string;
  id?: string;
  query?: string;
}

export interface ReadPromptTagInput {
  where?: ReadPromptTagWhereData;
  pagination?: PaginationData;
}

export interface ReadPromptTagOutput {
  count: number;
  data: PromptTagModel[];
}

export interface ReadPromptTagListOutput {
  id: string;
  name: string;
}

export interface CreateConversationData {
  id?: string;
  question: string;
  model: string;
}

export interface CreateConversationInput {
  data: CreateConversationData;
}

export interface ConversationTupleModel {
  id: string;
  name: string;
  createdDate: string;
  updatedDate: string;
  userId: string;
  messages: MessageTupleModel;
}

export interface CreateAudioConversationData {
  id: string;
  model: string;
}

export interface CreateAudioConversationInput {
  data: CreateAudioConversationData;
  /** @format binary */
  audio: File;
}

export interface ReadConversationWhereInput {
  id?: string;
}

export enum ConversationSortFieldEnum {
  CreatedDate = "createdDate",
  Name = "name",
}

export interface ReadConversationSortByData {
  /** @default "createdDate" */
  field?: ConversationSortFieldEnum;
  /** @default true */
  descending?: boolean;
}

export interface ReadConversationInput {
  where?: ReadConversationWhereInput;
  sortBy?: ReadConversationSortByData;
}

export interface ConversationModel {
  id: string;
  name: string;
  createdDate: string;
  promptId?: string;
  updatedDate: string;
  bucketId: string;
  userId: string;
  messages: MessageModel[];
}

export interface ReadConversationOutput {
  count: number;
  data: ConversationModel[];
}

export interface ReadConversationListWhereInput {
  id?: string;
  modelId?: string;
  query?: string;
}

export enum ConversationListSortFieldEnum {
  CreatedDate = "createdDate",
  Name = "name",
}

export interface ReadConversationListSortByData {
  /** @default "createdDate" */
  field?: ConversationListSortFieldEnum;
  /** @default true */
  descending?: boolean;
}

export interface ReadConversationListInput {
  where?: ReadConversationListWhereInput;
  pagination?: PaginationData;
  sortBy?: ReadConversationListSortByData;
}

export interface ReadConversationListDataOutput {
  id: string;
  name: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  userId: string;
  model: string;
  lastQuestion: MessageModel | null;
  lastAnswer: MessageModel | null;
}

export interface ReadConversationListOutput {
  count: number;
  data: ReadConversationListDataOutput[];
}

export interface UpdateConversationData {
  name?: string;
}

export interface UpdateConversationInput {
  data: UpdateConversationData;
  where: IdInput;
}

export interface CreateMessageData {
  message: string;
  model: string;
  conversationId: string;
}

export interface CreateMessageInput {
  data: CreateMessageData;
}

export interface ReadMessageCountInput {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
}

export interface ReadMessageCountOutput {
  count: number;
}

export interface CreateAudioMessageData {
  model: string;
  conversationId: string;
}

export interface CreateAudioMessageInput {
  data: CreateAudioMessageData;
  /** @format binary */
  audio: File;
}

export interface ReadUsageWhereInput {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  unit: number;
}

export interface ReadUsageInput {
  where: ReadUsageWhereInput;
}

export interface ReadUsageOutput {
  startDate: string;
  endDate: string;
  totalCost: string;
}

export interface ReadAudioUsageInput {
  pagination?: PaginationData;
}

export interface ReadAudioUsageData {
  id: string;
  name: string | null;
  totalDuration: number;
}

export interface ReadAudioUsageOutput {
  data: ReadAudioUsageData[];
}

export interface UsageType {
  amount: string;
  modelId: string;
}

export interface UsageModels {
  id: string;
  name: string;
}

export interface ReadUsageByAiModelOutput {
  usage: UsageType[];
  models: UsageModels[];
}

export interface CreateFeatureInputData {
  content: string;
  available: boolean;
}

export interface CreateSubscriptionInput {
  title: string;
  priceInTomans: string;
  description: string;
  hasLimit: boolean;
  limitInTomans?: string;
  supportedModels?: string[];
  features?: CreateFeatureInputData[];
}

export interface SubscriptionFeaturesModel {
  id: string;
  content: string;
  available: boolean;
  subscriptionId: string;
}

export interface SubscriptionModel {
  id: string;
  title: string;
  hasLimit: boolean;
  supportedModels: AiModelModel[];
  priceInToman: string;
  maxCreditInDollars?: string;
  description: string;
  features: SubscriptionFeaturesModel[];
}

export interface ChargeUserSubscriptionInput {
  /** @format date-time */
  subscriptionId: string;
  /** @format date-time */
  userId: string;
}

export interface UserSubscriptionModel {
  id: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  active: boolean;
  userId: string;
  userName: string;
  subscriptionId: string;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  userCostInTomans: string;
  smsSent: boolean;
  remainingCreditInTomans: string | null;
  reachedLimit: boolean;
}

export interface UpdateSubscriptionDataInput {
  title: string;
  priceInTomans: string;
  description: string;
  hasLimit: boolean;
  maxCreditInTomans?: string;
  supportedModels?: string[];
  features?: CreateFeatureInputData[];
}

export interface UpdateSubscriptionInput {
  data: UpdateSubscriptionDataInput;
  where: IdInput;
}

export interface ReadSubscriptionsWhereData {
  id?: string;
}

export interface ReadSubscriptionsInput {
  where?: ReadSubscriptionsWhereData;
}

export interface ReadSubscriptionsOutput {
  count: number;
  data: SubscriptionModel[];
}

export interface LimitedSubscriptionFeaturesModel {
  content: string;
  available: boolean;
  subscriptionId: string;
}

export interface LimitedSubscriptionModel {
  id: string;
  title: string;
  bold: boolean;
  supportedModels: AiModelModel[];
  priceInToman: string;
  description: string;
  features: LimitedSubscriptionFeaturesModel[];
}

export interface ReadLimitedSubscriptionsOutput {
  count: number;
  data: LimitedSubscriptionModel[];
}

export interface ReadUserSubscriptionWhereData {
  id?: string;
  userId?: string;
  /** @format date-time */
  startData?: string;
  /** @format date-time */
  endDate?: string;
  active?: boolean;
  query?: string;
}

export enum ReadUserSubscriptionSortEnum {
  StartDate = "startDate",
  EndDate = "endDate",
}

export interface ReadUserSubscriptionSortData {
  /** @default "endDate" */
  field?: ReadUserSubscriptionSortEnum;
  /** @default true */
  descending?: boolean;
}

export interface ReadUserSubscriptionInput {
  where?: ReadUserSubscriptionWhereData;
  sortBy?: ReadUserSubscriptionSortData;
  pagination?: PaginationTakeAllData;
}

export interface ReadUserSubscriptionOutput {
  count: number;
  data: UserSubscriptionModel[];
}

export interface ReadMySubscriptionWhereData {
  id?: string;
  /** @format date-time */
  startData?: string;
  /** @format date-time */
  endDate?: string;
  active?: boolean;
  query?: string;
}

export enum ReadMySubscriptionSortEnum {
  StartDate = "startDate",
  EndDate = "endDate",
}

export interface ReadMySubscriptionSortData {
  /** @default "endDate" */
  field?: ReadMySubscriptionSortEnum;
  /** @default true */
  descending?: boolean;
}

export interface ReadMySubscriptionInput {
  where?: ReadMySubscriptionWhereData;
  sortBy?: ReadMySubscriptionSortData;
  pagination?: PaginationTakeAllData;
}

export interface ReadHeavyUsersWhereData {
  id?: string;
  query?: string;
}

export interface ReadHeavyUsersInput {
  where?: ReadHeavyUsersWhereData;
  sortBy?: ReadUserSubscriptionSortData;
  pagination?: PaginationTakeAllData;
}

export interface BuySubscriptionInput {
  subscriptionId: string;
}

export interface BuySubscriptionOutput {
  url: string;
}

export interface MySubscriptionModel {
  id: string;
  title: string;
  supportedModels: AiModelModel[];
  priceInToman: string;
  description: string;
}

export interface AuthModel {
  role: string;
  email?: string;
  emailConfirmed: boolean;
  /** @format date-time */
  emailConfirmedAt?: string;
  phoneNumber?: string;
  phoneNumberConfirmed: boolean;
  /** @format date-time */
  phoneNumberConfirmedAt?: string;
}

export interface MeModel {
  id: string;
  freeCredit: string;
  paidCredit: string;
  lastTokenCountCharged: string;
  userSubscription: UserSubscriptionModel | null;
  subscription: MySubscriptionModel | null;
  name: string;
  avatar?: string;
  auth: AuthModel;
}

export interface LoginViaSmsInput {
  phoneNumber: string;
}

export interface ExchangePhoneOtpInput {
  code: string;
  phoneNumber: string;
}

export interface TokenModel {
  token: string;
  me: MeModel;
}

export interface ExchangeGoogleTokenInput {
  code: string;
}

export interface ExchangeGoogleJwtInput {
  jwt: string;
}

export interface ReadUsersDataInput {
  name?: string;
}

export interface ReadUsersInput {
  where?: ReadUsersDataInput;
  pagination?: PaginationData;
}

export interface ReadUserOutputData {
  id: string;
  name: string | null;
  avatar: string | null;
  conversationsCount: number;
  freeCredit: string;
  paidCredit: string;
  lastTokenCountCharged: string;
  activeSubscription: UserSubscriptionModel | null;
}

export interface ReadUserOutput {
  data: ReadUserOutputData[];
  count: number;
}

export interface ChangeUserNameInput {
  name: string;
}

export interface ChangeAvatarInput {
  /** @format binary */
  avatar: File;
}

export interface ReadNewUsersSummaryInput {
  day: number;
}

export interface ReadNewUsersSummaryOutput {
  amount: number;
  percent: number;
}

export enum MoneyToMessageInputTypeEnum {
  Money = "Money",
  Message = "Message",
}

export enum TransactionModelStatusEnum {
  Pending = "Pending",
  Failed = "Failed",
  Verified = "Verified",
  Redemmed = "Redemmed",
}

export enum ReadPaymentOutputDataProductEnum {
  Subscription = "Subscription",
  Credit = "Credit",
}

export enum ReadVerifiedTransactionOutputDataProductEnum {
  Subscription = "Subscription",
  Credit = "Credit",
}

export enum ReadMyPaymentOutputDataProductEnum {
  Subscription = "Subscription",
  Credit = "Credit",
}

export enum MessageModelTypeEnum {
  User = "User",
  Assistant = "Assistant",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Swagger APIs
 * @version 1.0
 * @contact
 *
 * The Swagger APIs description
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  credit = {
    /**
     * No description
     *
     * @tags Credit
     * @name UpdateCredit
     * @request POST:/credit/updateCredit
     * @response `200` `CreditModel`
     */
    updateCredit: (data: UpdateCreditInput, params: RequestParams = {}) =>
      this.request<CreditModel, any>({
        path: `/credit/updateCredit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name BuyCredit
     * @request POST:/credit/buyCredit
     * @response `200` `BuyCreditOutput`
     */
    buyCredit: (data: BuyCreditInput, params: RequestParams = {}) =>
      this.request<BuyCreditOutput, any>({
        path: `/credit/buyCredit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name MoneyToMessageAndViceVerse
     * @request POST:/credit/moneyToMessageAndViceVerse
     * @response `200` `MoneyToMessageOutput`
     */
    moneyToMessageAndViceVerse: (data: MoneyToMessageInput, params: RequestParams = {}) =>
      this.request<MoneyToMessageOutput, any>({
        path: `/credit/moneyToMessageAndViceVerse`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name CalcMessageToToman
     * @request POST:/credit/calcMessageToToman
     * @response `200` `CalcMessageToTomanOutput`
     */
    calcMessageToToman: (data: CalcMessageToTomanInput, params: RequestParams = {}) =>
      this.request<CalcMessageToTomanOutput, any>({
        path: `/credit/calcMessageToToman`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Credit
     * @name CalcTomanToMessage
     * @request POST:/credit/calcTomanToMessage
     * @response `200` `CalcTomanToMessageOutput`
     */
    calcTomanToMessage: (data: CalcTomanToMessageInput, params: RequestParams = {}) =>
      this.request<CalcTomanToMessageOutput, any>({
        path: `/credit/calcTomanToMessage`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  aiModel = {
    /**
     * No description
     *
     * @tags AiModel
     * @name ReadAiModel
     * @request POST:/ai-model/readAiModel
     * @response `200` `ReadAiModelOutput`
     */
    readAiModel: (data: ReadAiModelInput, params: RequestParams = {}) =>
      this.request<ReadAiModelOutput, any>({
        path: `/ai-model/readAiModel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiModel
     * @name UpdateAiModel
     * @request POST:/ai-model/updateAiModel
     * @response `200` `AiModelModel`
     */
    updateAiModel: (data: UpdateAiModelInput, params: RequestParams = {}) =>
      this.request<AiModelModel, any>({
        path: `/ai-model/updateAiModel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  referencePrice = {
    /**
     * No description
     *
     * @tags ReferencePrice
     * @name ReadReferencePrice
     * @request POST:/reference-price/readReferencePrice
     * @response `200` `ReadReferencePriceOutput`
     */
    readReferencePrice: (data: ReadReferencePriceInput, params: RequestParams = {}) =>
      this.request<ReadReferencePriceOutput, any>({
        path: `/reference-price/readReferencePrice`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  payment = {
    /**
     * No description
     *
     * @tags Payment
     * @name ReadPayment
     * @request POST:/payment/readPayment
     * @response `200` `ReadPaymentOutput`
     */
    readPayment: (data: ReadPaymentInput, params: RequestParams = {}) =>
      this.request<ReadPaymentOutput, any>({
        path: `/payment/readPayment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name VerifyPayment
     * @request POST:/payment/verifyPayment
     * @response `201` `void`
     */
    verifyPayment: (data: VerifyCreditPaymentInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/payment/verifyPayment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadVerifiedPayment
     * @request POST:/payment/readVerifiedPayment
     * @response `200` `ReadVerifiedTransactionOutput`
     */
    readVerifiedPayment: (data: ReadVerifiedPaymentInput, params: RequestParams = {}) =>
      this.request<ReadVerifiedTransactionOutput, any>({
        path: `/payment/readVerifiedPayment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadMyPayment
     * @request POST:/payment/readMyPayment
     * @response `200` `ReadMyPaymentOutput`
     */
    readMyPayment: (data: ReadMyPaymentInput, params: RequestParams = {}) =>
      this.request<ReadMyPaymentOutput, any>({
        path: `/payment/readMyPayment`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadIncome
     * @request POST:/payment/readIncome
     * @response `200` `ReadIncomeOutput`
     */
    readIncome: (data: ReadIncomeInput, params: RequestParams = {}) =>
      this.request<ReadIncomeOutput, any>({
        path: `/payment/readIncome`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadTotalIncome
     * @request POST:/payment/readTotalIncome
     * @response `200` `ReadTotalIncomeOutput`
     */
    readTotalIncome: (data: ReadTotalIncomeInput, params: RequestParams = {}) =>
      this.request<ReadTotalIncomeOutput, any>({
        path: `/payment/readTotalIncome`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadBenefit
     * @request POST:/payment/readBenefit
     * @response `200` `ReadBenefitOutput`
     */
    readBenefit: (data: ReadBenefitIncome, params: RequestParams = {}) =>
      this.request<ReadBenefitOutput, any>({
        path: `/payment/readBenefit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadCost
     * @request POST:/payment/readCost
     * @response `200` `ReadCostOutput`
     */
    readCost: (data: ReadCostIncome, params: RequestParams = {}) =>
      this.request<ReadCostOutput, any>({
        path: `/payment/readCost`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name ReadIncomeOutcome
     * @request POST:/payment/readIncomeOutcome
     * @response `200` `ReadIncomeOutcomeOutput`
     */
    readIncomeOutcome: (data: ReadIncomeOutcomeInput, params: RequestParams = {}) =>
      this.request<ReadIncomeOutcomeOutput, any>({
        path: `/payment/readIncomeOutcome`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  systemConfig = {
    /**
     * No description
     *
     * @tags SystemConfig
     * @name ReadSystemConfig
     * @request POST:/system-config/readSystemConfig
     * @response `200` `SystemConfigModel`
     */
    readSystemConfig: (params: RequestParams = {}) =>
      this.request<SystemConfigModel, any>({
        path: `/system-config/readSystemConfig`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemConfig
     * @name UpdateSystemConfig
     * @request POST:/system-config/updateSystemConfig
     * @response `200` `SystemConfigModel`
     */
    updateSystemConfig: (data: UpdateSystemConfigInput, params: RequestParams = {}) =>
      this.request<SystemConfigModel, any>({
        path: `/system-config/updateSystemConfig`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  prompt = {
    /**
     * No description
     *
     * @tags Prompt
     * @name CreatePromptConversation
     * @request POST:/prompt/createPromptConversation
     * @response `200` `PromptConversationModel`
     */
    createPromptConversation: (data: CreatePromptConversationInput, params: RequestParams = {}) =>
      this.request<PromptConversationModel, any>({
        path: `/prompt/createPromptConversation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name ReadPrompt
     * @request POST:/prompt/readPrompt
     * @response `200` `PromptModel`
     */
    readPrompt: (data: IdInput, params: RequestParams = {}) =>
      this.request<PromptModel, any>({
        path: `/prompt/readPrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name CreatePrompt
     * @request POST:/prompt/createPrompt
     * @response `200` `PromptModel`
     */
    createPrompt: (data: CreatePromptInput, params: RequestParams = {}) =>
      this.request<PromptModel, any>({
        path: `/prompt/createPrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name ChangePromptImage
     * @request POST:/prompt/changePromptImage
     * @response `200` `PromptModel`
     */
    changePromptImage: (data: ChangePromptImageInput, params: RequestParams = {}) =>
      this.request<PromptModel, any>({
        path: `/prompt/changePromptImage`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name UpdatePrompt
     * @request POST:/prompt/updatePrompt
     * @response `200` `PromptModel`
     */
    updatePrompt: (data: UpdatePromptInput, params: RequestParams = {}) =>
      this.request<PromptModel, any>({
        path: `/prompt/updatePrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name DeletePrompt
     * @request POST:/prompt/deletePrompt
     * @response `200` `PromptModel`
     */
    deletePrompt: (data: IdInput, params: RequestParams = {}) =>
      this.request<PromptModel, any>({
        path: `/prompt/deletePrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name UpdateLikePrompt
     * @request POST:/prompt/updateLikePrompt
     * @response `200` `UpdateLikePromptOutput`
     */
    updateLikePrompt: (data: IdInput, params: RequestParams = {}) =>
      this.request<UpdateLikePromptOutput, any>({
        path: `/prompt/updateLikePrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Prompt
     * @name UpdateUsageCountPrompt
     * @request POST:/prompt/updateUsageCountPrompt
     * @response `200` `UpdateUsageCountPromptOutput`
     */
    updateUsageCountPrompt: (data: IdInput, params: RequestParams = {}) =>
      this.request<UpdateUsageCountPromptOutput, any>({
        path: `/prompt/updateUsageCountPrompt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  promptTag = {
    /**
     * No description
     *
     * @tags PromptTag
     * @name CreatePromptTag
     * @request POST:/prompt-tag/createPromptTag
     * @response `200` `PromptTagModel`
     */
    createPromptTag: (data: CreatePromptTagInput, params: RequestParams = {}) =>
      this.request<PromptTagModel, any>({
        path: `/prompt-tag/createPromptTag`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PromptTag
     * @name UpdatePromptTag
     * @request POST:/prompt-tag/updatePromptTag
     * @response `200` `PromptTagModel`
     */
    updatePromptTag: (data: UpdatePromptTagInput, params: RequestParams = {}) =>
      this.request<PromptTagModel, any>({
        path: `/prompt-tag/updatePromptTag`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PromptTag
     * @name DeletePromptTag
     * @request POST:/prompt-tag/deletePromptTag
     * @response `200` `PromptTagModel`
     */
    deletePromptTag: (data: IdInput, params: RequestParams = {}) =>
      this.request<PromptTagModel, any>({
        path: `/prompt-tag/deletePromptTag`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PromptTag
     * @name ReadPromptTags
     * @request POST:/prompt-tag/readPromptTags
     * @response `200` `ReadPromptTagOutput`
     */
    readPromptTags: (data: ReadPromptTagInput, params: RequestParams = {}) =>
      this.request<ReadPromptTagOutput, any>({
        path: `/prompt-tag/readPromptTags`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PromptTag
     * @name ReadPromptTagList
     * @request POST:/prompt-tag/readPromptTagList
     * @response `200` `(ReadPromptTagListOutput)[]`
     */
    readPromptTagList: (params: RequestParams = {}) =>
      this.request<ReadPromptTagListOutput[], any>({
        path: `/prompt-tag/readPromptTagList`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  conversation = {
    /**
     * No description
     *
     * @tags Conversation
     * @name CreateConversation
     * @request POST:/conversation/createConversation
     * @response `200` `ConversationTupleModel`
     */
    createConversation: (data: CreateConversationInput, params: RequestParams = {}) =>
      this.request<ConversationTupleModel, any>({
        path: `/conversation/createConversation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation
     * @name CreateAudioConversation
     * @request POST:/conversation/createAudioConversation
     * @response `200` `ConversationTupleModel`
     */
    createAudioConversation: (data: CreateAudioConversationInput, params: RequestParams = {}) =>
      this.request<ConversationTupleModel, any>({
        path: `/conversation/createAudioConversation`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation
     * @name ReadConversation
     * @request POST:/conversation/readConversation
     * @response `200` `ReadConversationOutput`
     */
    readConversation: (data: ReadConversationInput, params: RequestParams = {}) =>
      this.request<ReadConversationOutput, any>({
        path: `/conversation/readConversation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation
     * @name ReadConversationList
     * @request POST:/conversation/readConversationList
     * @response `200` `ReadConversationListOutput`
     */
    readConversationList: (data: ReadConversationListInput, params: RequestParams = {}) =>
      this.request<ReadConversationListOutput, any>({
        path: `/conversation/readConversationList`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation
     * @name DeleteConversation
     * @request POST:/conversation/deleteConversation
     * @response `200` `ConversationModel`
     */
    deleteConversation: (data: IdInput, params: RequestParams = {}) =>
      this.request<ConversationModel, any>({
        path: `/conversation/deleteConversation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation
     * @name UpdateConversation
     * @request POST:/conversation/updateConversation
     * @response `200` `ConversationModel`
     */
    updateConversation: (data: UpdateConversationInput, params: RequestParams = {}) =>
      this.request<ConversationModel, any>({
        path: `/conversation/updateConversation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  message = {
    /**
     * No description
     *
     * @tags Message
     * @name CreateMessage
     * @request POST:/message/createMessage
     * @response `200` `MessageTupleModel`
     */
    createMessage: (data: CreateMessageInput, params: RequestParams = {}) =>
      this.request<MessageTupleModel, any>({
        path: `/message/createMessage`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name MessageControllerReadMessageCount
     * @request POST:/message/readMessageCount
     * @response `200` `ReadMessageCountOutput`
     */
    messageControllerReadMessageCount: (data: ReadMessageCountInput, params: RequestParams = {}) =>
      this.request<ReadMessageCountOutput, any>({
        path: `/message/readMessageCount`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message
     * @name CreateAudioMessage
     * @request POST:/message/createAudioMessage
     * @response `200` `MessageTupleModel`
     */
    createAudioMessage: (data: CreateAudioMessageInput, params: RequestParams = {}) =>
      this.request<MessageTupleModel, any>({
        path: `/message/createAudioMessage`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  statistics = {
    /**
     * No description
     *
     * @tags Statistics
     * @name ReadUsage
     * @request POST:/statistics/readUsage
     * @response `200` `(ReadUsageOutput)[]`
     */
    readUsage: (data: ReadUsageInput, params: RequestParams = {}) =>
      this.request<ReadUsageOutput[], any>({
        path: `/statistics/readUsage`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Statistics
     * @name ReadAudioUsage
     * @request POST:/statistics/readAudioUsage
     * @response `200` `ReadAudioUsageOutput`
     */
    readAudioUsage: (data: ReadAudioUsageInput, params: RequestParams = {}) =>
      this.request<ReadAudioUsageOutput, any>({
        path: `/statistics/readAudioUsage`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Statistics
     * @name ReadUsageByAiModel
     * @request POST:/statistics/readUsageByAiModel
     * @response `200` `ReadUsageByAiModelOutput`
     */
    readUsageByAiModel: (params: RequestParams = {}) =>
      this.request<ReadUsageByAiModelOutput, any>({
        path: `/statistics/readUsageByAiModel`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  serve = {
    /**
     * No description
     *
     * @tags Serve
     * @name GetFile
     * @request GET:/serve/{id}
     * @response `200` `void`
     */
    getFile: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/serve/${id}`,
        method: "GET",
        ...params,
      }),
  };
  subscription = {
    /**
     * No description
     *
     * @tags Subscription
     * @name CreateSubscription
     * @request POST:/subscription/createSubscription
     * @response `200` `SubscriptionModel`
     */
    createSubscription: (data: CreateSubscriptionInput, params: RequestParams = {}) =>
      this.request<SubscriptionModel, any>({
        path: `/subscription/createSubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name DeleteSubscription
     * @request POST:/subscription/deleteSubscription
     * @response `200` `SubscriptionModel`
     */
    deleteSubscription: (data: IdInput, params: RequestParams = {}) =>
      this.request<SubscriptionModel, any>({
        path: `/subscription/deleteSubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ChargeUserSubscription
     * @request POST:/subscription/chargeUserSubscription
     * @response `200` `UserSubscriptionModel`
     */
    chargeUserSubscription: (data: ChargeUserSubscriptionInput, params: RequestParams = {}) =>
      this.request<UserSubscriptionModel, any>({
        path: `/subscription/chargeUserSubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name UpdateSubscription
     * @request POST:/subscription/updateSubscription
     * @response `200` `SubscriptionModel`
     */
    updateSubscription: (data: UpdateSubscriptionInput, params: RequestParams = {}) =>
      this.request<SubscriptionModel, any>({
        path: `/subscription/updateSubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReadSubscriptions
     * @request POST:/subscription/readSubscriptions
     * @response `200` `ReadSubscriptionsOutput`
     */
    readSubscriptions: (data: ReadSubscriptionsInput, params: RequestParams = {}) =>
      this.request<ReadSubscriptionsOutput, any>({
        path: `/subscription/readSubscriptions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReadLimitedSubscriptions
     * @request POST:/subscription/readLimitedSubscriptions
     * @response `200` `ReadLimitedSubscriptionsOutput`
     */
    readLimitedSubscriptions: (data: ReadSubscriptionsInput, params: RequestParams = {}) =>
      this.request<ReadLimitedSubscriptionsOutput, any>({
        path: `/subscription/readLimitedSubscriptions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReadUserSubscription
     * @request POST:/subscription/readUserSubscription
     * @response `200` `ReadUserSubscriptionOutput`
     */
    readUserSubscription: (data: ReadUserSubscriptionInput, params: RequestParams = {}) =>
      this.request<ReadUserSubscriptionOutput, any>({
        path: `/subscription/readUserSubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReadMySubscriptions
     * @request POST:/subscription/readMySubscriptions
     * @response `200` `ReadUserSubscriptionOutput`
     */
    readMySubscriptions: (data: ReadMySubscriptionInput, params: RequestParams = {}) =>
      this.request<ReadUserSubscriptionOutput, any>({
        path: `/subscription/readMySubscriptions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name ReadHeavyUsers
     * @request POST:/subscription/readHeavyUsers
     * @response `200` `ReadUserSubscriptionOutput`
     */
    readHeavyUsers: (data: ReadHeavyUsersInput, params: RequestParams = {}) =>
      this.request<ReadUserSubscriptionOutput, any>({
        path: `/subscription/readHeavyUsers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription
     * @name BuySubscription
     * @request POST:/subscription/buySubscription
     * @response `200` `BuySubscriptionOutput`
     */
    buySubscription: (data: BuySubscriptionInput, params: RequestParams = {}) =>
      this.request<BuySubscriptionOutput, any>({
        path: `/subscription/buySubscription`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name Me
     * @request POST:/user/me
     * @response `200` `MeModel`
     */
    me: (params: RequestParams = {}) =>
      this.request<MeModel, any>({
        path: `/user/me`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Requires Captcha
     *
     * @tags User
     * @name LoginViaSms
     * @request POST:/user/loginViaSms
     * @response `204` `void`
     */
    loginViaSms: (data: LoginViaSmsInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user/loginViaSms`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ExchangePhoneOtp
     * @request POST:/user/exchangePhoneOtp
     * @response `200` `TokenModel`
     */
    exchangePhoneOtp: (data: ExchangePhoneOtpInput, params: RequestParams = {}) =>
      this.request<TokenModel, any>({
        path: `/user/exchangePhoneOtp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ExchangeGoogleToken
     * @request POST:/user/exchangeGoogleToken
     * @response `200` `TokenModel`
     */
    exchangeGoogleToken: (data: ExchangeGoogleTokenInput, params: RequestParams = {}) =>
      this.request<TokenModel, any>({
        path: `/user/exchangeGoogleToken`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ExchangeGoogleJwt
     * @request POST:/user/exchangeGoogleJwt
     * @response `200` `TokenModel`
     */
    exchangeGoogleJwt: (data: ExchangeGoogleJwtInput, params: RequestParams = {}) =>
      this.request<TokenModel, any>({
        path: `/user/exchangeGoogleJwt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ReadUsers
     * @request POST:/user/readUsers
     * @response `200` `ReadUserOutput`
     */
    readUsers: (data: ReadUsersInput, params: RequestParams = {}) =>
      this.request<ReadUserOutput, any>({
        path: `/user/readUsers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ChangeUserName
     * @request POST:/user/changeUserName
     * @response `200` `MeModel`
     */
    changeUserName: (data: ChangeUserNameInput, params: RequestParams = {}) =>
      this.request<MeModel, any>({
        path: `/user/changeUserName`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ChangeUserAvatar
     * @request POST:/user/changeUserAvatar
     * @response `200` `MeModel`
     */
    changeUserAvatar: (data: ChangeAvatarInput, params: RequestParams = {}) =>
      this.request<MeModel, any>({
        path: `/user/changeUserAvatar`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ReadNewUsersSummary
     * @request POST:/user/readNewUsersSummary
     * @response `200` `ReadNewUsersSummaryOutput`
     */
    readNewUsersSummary: (data: ReadNewUsersSummaryInput, params: RequestParams = {}) =>
      this.request<ReadNewUsersSummaryOutput, any>({
        path: `/user/readNewUsersSummary`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
